import { useEffect, useState } from "react";
import { FileText, Trash2, Upload, Plus } from "lucide-react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const TYPES = [
    { v: "reglamento", l: "Reglamento" },
    { v: "horarios", l: "Horarios" },
    { v: "contactos", l: "Contactos" },
    { v: "general", l: "General" },
];

export default function InfoColegio() {
    const [docs, setDocs] = useState([]);
    const [creating, setCreating] = useState(false);
    const [form, setForm] = useState({ title: "", doc_type: "general", content_preview: "" });
    const [file, setFile] = useState(null);
    const [saving, setSaving] = useState(false);

    async function load() {
        const r = await api.get("/school-docs");
        setDocs(r.data || []);
    }
    useEffect(() => {
        load();
    }, []);

    async function save() {
        setSaving(true);
        try {
            let file_id = null;
            if (file) {
                const fd = new FormData();
                fd.append("file", file);
                const { data } = await api.post("/files/upload", fd, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                file_id = data.id;
            }
            await api.post("/school-docs", { ...form, file_id });
            toast.success("Documento agregado");
            setCreating(false);
            setForm({ title: "", doc_type: "general", content_preview: "" });
            setFile(null);
            load();
        } catch (e) {
            toast.error(e.response?.data?.detail || "Error");
        } finally {
            setSaving(false);
        }
    }

    async function remove(id) {
        if (!confirm("¿Eliminar documento?")) return;
        await api.delete(`/school-docs/${id}`);
        toast.success("Eliminado");
        load();
    }

    return (
        <div className="p-6 md:p-10 fade-in" data-testid="info-colegio-page">
            <div className="flex items-center justify-between mb-6">
                <div>
                    <h1 className="text-3xl font-semibold">Información del Colegio</h1>
                    <p className="text-edu-body">
                        Estos documentos alimentan la IA de Consultas del Colegio.
                    </p>
                </div>
                <button
                    onClick={() => setCreating(true)}
                    className="edu-btn-primary px-4 py-2.5 text-sm inline-flex items-center gap-2"
                    data-testid="create-doc"
                >
                    <Plus size={14} /> Nuevo Documento
                </button>
            </div>

            <div className="grid md:grid-cols-2 gap-5">
                {docs.length === 0 && <p className="text-edu-muted col-span-2">Sin documentos.</p>}
                {docs.map((d) => (
                    <div key={d.id} className="edu-card p-5" data-testid={`doc-${d.id}`}>
                        <div className="flex items-start justify-between mb-2">
                            <div>
                                <span className="edu-pill bg-edu-navy/10 text-edu-navy capitalize">
                                    {d.doc_type}
                                </span>
                                <h3 className="text-lg font-semibold mt-2">{d.title}</h3>
                            </div>
                            <button
                                onClick={() => remove(d.id)}
                                className="text-red-600 p-2 hover:bg-red-50 rounded-lg"
                            >
                                <Trash2 size={14} />
                            </button>
                        </div>
                        <p className="text-sm text-edu-body line-clamp-4">{d.content_preview}</p>
                    </div>
                ))}
            </div>

            {creating && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
                    <div className="edu-card p-6 max-w-md w-full">
                        <h3 className="text-xl font-semibold mb-4">Nuevo Documento</h3>
                        <div className="space-y-3">
                            <input
                                placeholder="Título"
                                value={form.title}
                                onChange={(e) => setForm({ ...form, title: e.target.value })}
                                className="edu-input w-full"
                                data-testid="doc-title"
                            />
                            <select
                                value={form.doc_type}
                                onChange={(e) => setForm({ ...form, doc_type: e.target.value })}
                                className="edu-input w-full"
                            >
                                {TYPES.map((t) => (
                                    <option key={t.v} value={t.v}>
                                        {t.l}
                                    </option>
                                ))}
                            </select>
                            <textarea
                                placeholder="Contenido (resumen) — usado por la IA…"
                                value={form.content_preview}
                                onChange={(e) => setForm({ ...form, content_preview: e.target.value })}
                                rows={5}
                                className="edu-input w-full"
                                data-testid="doc-content"
                            />
                            <input
                                type="file"
                                onChange={(e) => setFile(e.target.files?.[0])}
                                className="edu-input w-full"
                            />
                            <div className="flex justify-end gap-3 pt-2">
                                <button
                                    onClick={() => setCreating(false)}
                                    className="px-4 py-2 text-sm rounded-xl border border-edu"
                                >
                                    Cancelar
                                </button>
                                <button
                                    onClick={save}
                                    disabled={saving}
                                    className="edu-btn-primary px-4 py-2 text-sm"
                                    data-testid="save-doc"
                                >
                                    {saving ? "Guardando…" : "Guardar"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
